// Settings → Lists. Master/detail, with add/remove of list items.

import { useState } from "react";
import { useAppData } from "../store";
import { Btn, Tag } from "../components/Primitives";
import { Ic } from "../components/Icon";

export function ListsScreen() {
  const { data, saveConfig } = useAppData();
  const lists = data?.config.lists ?? [];
  const [pick, setPick] = useState(lists[0]?.name ?? "");
  const cur = lists.find((l) => l.name === pick) ?? lists[0];
  const [entry, setEntry] = useState("");

  if (!data || !cur) return null;

  const updateList = async (next: typeof lists[number]) => {
    await saveConfig({
      ...data.config,
      lists: data.config.lists.map((l) => l.name === cur.name ? next : l),
    });
  };

  const addItem = async () => {
    const v = entry.trim();
    if (!v || cur.items.includes(v)) { setEntry(""); return; }
    await updateList({ ...cur, items: [...cur.items, v], count: cur.items.length + 1 });
    setEntry("");
  };

  const removeItem = async (item: string) => {
    await updateList({
      ...cur,
      items: cur.items.filter((x) => x !== item),
      count: cur.items.length - 1,
    });
  };

  const newList = async () => {
    const name = prompt("New list name?")?.trim();
    if (!name || lists.some((l) => l.name === name)) return;
    const next = [...data.config.lists, { name, items: [], count: 0 } as any];
    await saveConfig({ ...data.config, lists: next });
    setPick(name);
  };

  return (
    <div className="page">
      <div className="topbar">
        <span className="crumb">Settings</span>
        <span className="crumb-sep">/</span>
        <h1>Lists</h1>
        <span className="grow" />
        <Btn size="sm" ico="plus" kind="primary" onClick={newList}>New list</Btn>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "260px 1fr", flex: 1, minHeight: 0 }}>
        <div style={{
          borderRight: "1px solid var(--border)",
          padding: "12px 10px", background: "var(--bg)", overflowY: "auto",
        }}>
          {lists.map((l) => (
            <div key={l.name} onClick={() => setPick(l.name)} style={{
              padding: "9px 10px", borderRadius: 5, cursor: "pointer",
              background: l.name === pick ? "var(--surface)" : "transparent",
              boxShadow: l.name === pick ? "0 0 0 1px var(--border)" : "none",
              display: "flex", alignItems: "center", gap: 8,
              fontSize: 13, marginBottom: 1,
              fontWeight: l.name === pick ? 500 : 400,
              color: l.name === pick ? "var(--ink)" : "var(--ink-2)",
            }}>
              <span style={{ flex: 1 }}>{l.name}</span>
              <span style={{ color: "var(--ink-3)", fontSize: 11 }}>{l.items.length}</span>
            </div>
          ))}
        </div>
        <div className="scroll" style={{ padding: "24px 28px 60px" }}>
          <div style={{ fontSize: 22, fontWeight: 600, letterSpacing: "-0.015em" }}>{cur.name}</div>
          <div style={{ color: "var(--ink-3)", fontSize: 12.5, marginTop: 4 }}>
            {cur.items.length} entries
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 20 }}>
            {cur.items.map((u) => (
              <Tag outlined key={u}>
                {u}
                <span onClick={(e) => { e.stopPropagation(); removeItem(u); }}
                      style={{ cursor: "pointer", marginLeft: 4 }}>
                  <Ic name="x" size={11} />
                </span>
              </Tag>
            ))}
            <div className="input" style={{ width: 200 }}>
              <input
                placeholder="Add an entry…" value={entry}
                onChange={(e) => setEntry(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") addItem(); }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
